import BackstageProjectLayout from "./BackstageProjectLayout"

export default BackstageProjectLayout
